import {
  ACTIVITY_DISTRIBUTOR_ADDRESS,
  ACTIVITY_ENROLLMENT_ENABLED,
  POINTS_ENABLED,
  REFERRAL_ENABLED,
} from '@/client/confs/app';
import { resolveRewardsEntry } from '@/client/confs/rewards-entry';
import { useSignedUserInfo } from '@/client/hooks/use-signed-user-info';
import { api } from '@/client/utils/api';
import { useMemo } from 'react';

const FLAGS = {
  activityEnrollmentEnabled: ACTIVITY_ENROLLMENT_ENABLED,
  activityDistributorAddress: ACTIVITY_DISTRIBUTOR_ADDRESS,
  pointsEnabled: POINTS_ENABLED,
  referralEnabled: REFERRAL_ENABLED,
};

// Nav rewards entry for the header icon and the more-slider item.
export const useRewardsEntry = () => {
  const { data: signer } = useSignedUserInfo(api);
  return useMemo(() => resolveRewardsEntry(FLAGS, signer?.uid), [signer?.uid]);
};
